import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../utils/api';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';

export const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getUnmappedDataFeed: build.query({
      query: (args) => {
        if (args) {
          const { page, perPage, searchParams = '' } = args;

          return `${apiUrl.unmappedDataFeed}?perPage=${perPage || DEFAULT_PER_PAGE}&page=${
            page || DEFAULT_PAGE
          }&${searchParams}`;
        }
        return `${apiUrl.unmappedDataFeed}`;
      },
      transformResponse: (responseData) => {
        const pagination = responseData?.pagination;
        const feedMappingIssues = responseData?.data?.feedMappingIssues || [];
        return { feedMappingIssues, pagination };
      },
      providesTags: ['UnmappedDataFeed'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetUnmappedDataFeedQuery, useLazyGetUnmappedDataFeedQuery } = extendedApi;
